import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { CustomerService } from "../../../services/customer-service";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { DistrictService } from "../../../services/district-service";
import Select from "react-select";

export const Profilecontent = (props) => {
  const { customerID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);
  const [districts, setDistricts] = useState([]);

  var bodyFormData = new FormData();

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await CustomerService.customerUpdate(customerID, values);

      setSubmitLoading(true);
      notify("Customer successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }

      //show error toast
    }
  };

  const fetchDistrictsData = async () => {
    try {
      const districtsDetails = await DistrictService.districtsDetails();
      setDistricts(districtsDetails);
    } catch (error) {
    }
  };

  useEffect(() => {
    CustomerDetailSearchID();
    fetchDistrictsData();
  }, []);

  const [customerinfo, setCustomerInfo] = useState({
    name: "",
    phone: "",
    whatsapp_number: "",
    birthday: "",
    address: "",
    district: 0,
    city: "",
    status: "",
  });

  const CustomerDetailSearchID = async () => {
    try {
    } catch (err) {
      //toast
      console.error(err);
    }
    const result = await CustomerService.customerDetailsID(customerID);

    const info = {};

    const customerdata = result;

    info.name = customerdata.name;
    info.phone = customerdata.phone;
    info.whatsapp_number = customerdata.whatsapp_number;
    info.birthday = customerdata.birthday;
    info.address = customerdata.address;
    info.district = customerdata.district;
    info.city = customerdata.city;
    info.status = customerdata.status;
    setCustomerInfo(info);
  };

  let districtOptions = districts.map((district) => ({
    value: district.id,
    label: district.name_en,
  }));

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit Profile</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  name: customerinfo.name,
                  phone: customerinfo.phone,
                  whatsapp_number: customerinfo.whatsapp_number,
                  birthday: customerinfo.birthday,
                  address: customerinfo.address,
                  district: customerinfo.district,
                  city: customerinfo.city,
                  status: customerinfo.status,
                }}
                validationSchema={Yup.object().shape({
                  name: Yup.string().required("Required"),
                  phone: Yup.string()
                  .required("Required")
                  .matches(phoneRegExp, "Phone number is not valid"),
                  whatsapp_number: Yup.string()
                    .required("Required")
                    .matches(phoneRegExp, "Phone number is not valid"),
                  birthday: Yup.string().required("Required"),
                  address: Yup.string().required("Required"),
                  district: Yup.string().required("Required"),
                  city: Yup.string().required("Required"),
                  status: Yup.string().required("Required"),
                  // image: Yup.string().required("Please, select an image"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue,
                }) => (
                  <div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Name</label>
                        <div className="input-group">
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            id="nameid"
                            placeholder="Name"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.name && errors.name}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Phone</label>
                        <div className="input-group">
                          <input
                            name="phone"
                            type="text"
                            className="form-control"
                            id="phoneid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.phone && errors.phone}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Whatsapp Number</label>
                        <div className="input-group">
                          <input
                            name="whatsapp_number"
                            type="text"
                            className="form-control"
                            id="whatsapp_numberid"
                            placeholder="Phone"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.whatsapp_number}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.whatsapp_number && errors.whatsapp_number}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom09">Birthday</label>
                        <div className="input-group">
                          <input
                            name="birthday"
                            type="date"
                            className="form-control"
                            id="birthdayid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.birthday}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.birthday && errors.birthday}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom09">Address</label>
                        <div className="input-group">
                          <input
                            name="address"
                            type="text"
                            className="form-control"
                            id="addressid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.address}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.address && errors.address}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom09">District</label>
                          <Select
                            options={districtOptions}
                            onChange={(selectedOption)=>{
                              setFieldValue('district', selectedOption ? selectedOption.value : "")
                            }}
                            isClearable
                            placeholder="Select District"
                            value={districtOptions.find(option => option.value === values.district)}
                          />
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.district && errors.district}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom09">City</label>
                        <div className="input-group">
                          <input
                            name="city"
                            type="text"
                            className="form-control"
                            id="cityid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.city}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.city && errors.city}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom15">
                          Change Status
                        </label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="selectstatus"
                            required
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="BLOCKED">BLOCKED</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>

                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Save and Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profilecontent;
